import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {TuiAlertService} from '@taiga-ui/core';
import {AuthService} from '../../../_services/auth/auth.service';

@Component({
  selector: 'app-password-reset-request',
  templateUrl: './password-reset-request.component.html',
  styleUrls: ['./password-reset-request.component.css'],
  standalone: false,
})
export class PasswordResetRequestComponent implements OnInit {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly alerts: TuiAlertService,
    private readonly translate: TranslateService,
    private fb: FormBuilder,
  ) {}

  passwordReset!: FormGroup;

  ngOnInit() {
    this.initializeForm();
  }

  initializeForm() {
    this.passwordReset = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  onSubmit() {
    if (this.passwordReset.invalid) {
      this.alerts
        .open(
          this.translate.instant(
            'features.passwordResetRequest.toast.formError',
          ),
          {
            label: this.translate.instant('common.status.error'),
            appearance: 'error',
          },
        )
        .subscribe();
      return;
    }

    const {email} = this.passwordReset.value;

    this.authService.passwordResetRequest(email).subscribe({
      next: () => {
        void this.router.navigate(['/login']).then(() => {
          this.alerts
            .open(
              this.translate.instant(
                'features.passwordResetRequest.toast.success',
              ),
              {
                label: this.translate.instant('common.status.success'),
                appearance: 'success',
              },
            )
            .subscribe();
        });
      },
      error: () => {
        void this.router.navigate(['/login']).then(() => {
          this.alerts
            .open(
              this.translate.instant(
                'features.passwordResetRequest.toast.success',
              ),
              {
                label: this.translate.instant('common.status.success'),
                appearance: 'success',
              },
            )
            .subscribe();
        });
      },
    });
  }
}
